import React from 'react';

import { Box } from '@chakra-ui/react';
import { customTheme } from 'theme';

export const CommandBox = ({ children }) => {
  return (
    <Box
      py={4}
      px={2}
      border="1px solid"
      borderColor="componentBorder"
      bg={customTheme.colors.gray['50']}
      borderRadius={6}
      fontFamily="Consolas"
    >
      {children}
    </Box>
  );
};
